export default __webpack_public_path__ + "static/media/轮播首图13.d9fe780d.png";